import React from 'react';
import { Modal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
import { useTranslation } from 'react-i18next';
import ProductFormContainer from '@/containers/admin/ProductFormContainer';

interface ProductFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  productId?: string | null;
}

const ProductFormModal: React.FC<ProductFormModalProps> = ({ isOpen, onClose, productId }) => {
  const { t } = useTranslation('admin');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="2xl" placement="center" backdrop="blur" scrollBehavior="inside">
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          {productId ? t('products.modal.edit.title') : t('products.modal.create.title')}
        </ModalHeader>
        <ModalBody>
          <ProductFormContainer productId={productId} onSuccess={onClose} onCancel={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ProductFormModal;
